import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { ReactComponent as Pencil } from '@styles/icons/pencil.svg';
import React from 'react';

export const PencilIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={Pencil} viewBox={'-5 -3 22 22'} />
);

export default PencilIcon;
